module.exports = {
      id: "author-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#author",
      toString: function () {
        return this.url;
      }
    }